export default {
  userGroupManagement: {
    Name: '用户组名称',
    Status: '状态',
    create: '创建用户组',
    edit: '编辑用户组',
    creator: '创建人',
    userGroup: '用户组',
    userGroupList: '用户组列表',
    accountList: '账号列表',
    country: '国家'
  }
};
